import { render, staticRenderFns } from "./PatientDetailSurgeriesPage.vue?vue&type=template&id=5bfe850d&scoped=true&"
import script from "./PatientDetailSurgeriesPage.vue?vue&type=script&lang=js&"
export * from "./PatientDetailSurgeriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe850d",
  null
  
)

export default component.exports